import Select from "react-select";
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 1, label:  "Autoconsumo remoto" },
    { value: 2, label:  "Múltiplas Unidades Consumidoras" },
    { value: 3, label:  "Geração Compartilhada" },
    { value: 4, label:  "Autoconsumo local" } 
];

const ModalidadeGD = ({ field, placeholder, name, id, disabled=false, onKeyDown, className="" }) => {
    return (
        <Select 
            options={options}
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
            onKeyDown={onKeyDown}
            className={className}
        />
    )
}

export { ModalidadeGD, options as OpcoesModalidadeGD }